<template>
  <div></div>
</template>

<script>
import { redirectToTarget } from '@/components/validation/validateRedirect';

export default {
  name: 'LoginCallback',
  async mounted() {
    try {
      await this.$store.dispatch('session/handleLoginCallback');
      const redirectRoute = localStorage.getItem('idp_redirect');
      localStorage.removeItem('idp_redirect');
      localStorage.removeItem('loginErrorMessage');

      // logic kept for PCG access to risk assessment
      const redirectUrlQueryParam = window.location.search.split('redirect-url=')[1];
      if (redirectUrlQueryParam) {
        if (!redirectToTarget(redirectUrlQueryParam)) {
          await this.$store.dispatch('session/logout', this.$route.query);
        }
        return;
      }

      this.$router.push(redirectRoute || '/excursions');
    } catch (error) {
      localStorage.setItem('loginErrorMessage', error);
      await this.$store.dispatch('session/logout', this.$route.query);
    }
  }
};
</script>
